import { render, staticRenderFns } from "./NewApproveLine.vue?vue&type=template&id=59043146&scoped=true&"
import script from "./NewApproveLine.vue?vue&type=script&lang=js&"
export * from "./NewApproveLine.vue?vue&type=script&lang=js&"
import style0 from "./NewApproveLine.vue?vue&type=style&index=0&id=59043146&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59043146",
  null
  
)

export default component.exports